<template>
	<div class="card vue-survey-builder-content vsb-content">
		<div class="card-body">
			<select class="form-select vsb-select" v-model="selectedType" v-on:change="questionTypeChanged(selectedType)">
				<option v-for="(questionType, index) in questionTypes" :value="questionType.value" :key="index"
				        :disabled="questionType.value === 'DEFAULT'" :selected="questionType.value === 'DEFAULT'">
					{{ questionType.label }}
				</option>
			</select>
			<div class="question-section">
	            <validation-observer ref="observer" v-slot="{ handleSubmit }">
	                <form @submit.prevent="handleSubmit(saveQuestion);">
		                <template v-if="selectedType !== 'DEFAULT'">
			                <validation-provider v-if="selectedType !== 'SECTION_TITLE'" v-slot="{ errors }" class="form-group pb-3" name="body" rules="required" tag="div">
				                <div class="vsb-choices-text">{{ __('questionnaires.question') }}</div>
				                <textarea :class="{'is-invalid': errors.length}" class="form-control" placeholder="Enter question text" v-model="question.body"
				                          rows="3">
		                    </textarea>
				                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
			                </validation-provider>
			                <validation-provider v-if="selectedType === 'SECTION_TITLE'" v-slot="{ errors }" class="form-group pb-3" name="body" rules="required" tag="div">
				                <div class="vsb-choices-text">Title</div>
				                <textarea :class="{'is-invalid': errors.length}" class="form-control" placeholder="Enter title text" v-model="question.body" rows="3">
		                    </textarea>
				                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
			                </validation-provider>
			                <div class="">
				                <label class="display-block mb-2">
					                <input type="checkbox" class="" v-model="question.required" name="required"/>
					                {{ __('questionnaires.required') }}
				                </label>
			                </div>
			                <div class="">
				                <label class="display-block mb-2">
					                <input type="checkbox" class="" v-model="question.showNa" name="showNa"/>
					                {{ __('questionnaires.show-na-option') }}
				                </label>
			                </div>
			                <div class="" v-if="selectedType === 'BOOLEAN'">
				                <div class="vsb-choices-text">{{ __('questionnaires.answerlabels') }}</div>
				                <div class="" v-for="(option, index) in question.options" :key="index">
					                <div class="clear-both">
						                <validation-provider v-slot="{ errors }" :name="`${index === 0 ? 'first option' : 'second option'}`" rules="required">
							                <input type="text":class="{'is-invalid': errors.length}" class="form-control mb-2" placeholder="Enter an answer choice"
							                       v-model="option.body">
							                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
						                </validation-provider>
						                <button class="vsb-btn-link color-red width-10 mt-0"
						                        v-on:click="deleteQuestionOptionItem(question.options, index)" v-if="index > 1">Remove
						                </button>
					                </div>
				                </div>
			                </div>
			                <div class="" v-if="selectedType === 'DATE'">
				                <label class="vsb-block"><input type="radio" v-model="question.dateFormat" value="MM/DD/YY">
					                MM/DD/YY</label>
				                <label class="vsb-block"><input type="radio" v-model="question.dateFormat" value="DD/MM/YY">
					                DD/MM/YY</label>
				                <label class="vsb-block"><input type="radio" v-model="question.dateFormat" value="MM/DD/YYYY">
					                MM/DD/YYYY</label>
				                <label class="vsb-block"><input type="radio" v-model="question.dateFormat" value="DD/MM/YYYY">
					                DD/MM/YYYY</label>
			                </div>
			                <div class="" v-if="selectedType === 'MULTI_CHOICE'">
				                <div class="vsb-choices-text">{{ __('questionnaires.answerlabels') }}</div>
				                <div class="" v-for="(option, index) in question.options" :key="index">
					                <div class="row">
						                <div class="col-md-10">
							                <validation-provider v-slot="{ errors }" class="form-group clear-both mb-2" :name="`multi choice ` + `${index + 1}`" rules="required" tag="div">
								                <input type="text" :class="{'is-invalid': errors.length}" class="form-control" placeholder=""
								                       v-model="option.body">
								                <div class="d-flex justify-content-between mt-0 mb-2">
									                <div class="col-6">
										                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
									                </div>
									                <button class="col-6 vsb-btn-link color-red text-right" v-on:click="deleteQuestionOptionItem(question.options, index)" v-if="index > 1">{{ __('actions.delete') }}
									                </button>
								                </div>
							                </validation-provider>
						                </div>
					                </div>
				                </div>
				                <div class="display-block">
					                <button class="vsb-btn-link color-blue" v-on:click="addAnotherAnswer()">{{ __('questionnaires.question-answer-add') }}</button>
				                </div>
			                </div>
			                <div class="" v-if="selectedType === 'NUMBER'">
				                <label class="display-block mb-2">
					                <input type="checkbox" class="" v-model="question.hasUnits" name="hasUnits"/>
					                <span class="">Answer label
								    <input type="text" class="form-control form-control-sm width-10" placeholder="ex. mins, lbs, days" v-model="question.units" :disabled="!question.hasUnits">
							    </span>
				                </label>
				                <label class="display-block">
					                <input type="checkbox" v-model="question.hasMinMax" name="subType"/>
					                <span class="">Min/max value
					            <input type="number" class="form-control form-control-sm width-10" v-model.number="question.minValue" placeholder="min" min="1" max="2048"
					                   :disabled="!question.hasMinMax">
					            <span>to</span>
					            <input type="number" class="form-control form-control-sm width-10" v-model.number="question.maxValue" placeholder="max" min="1" max="2048"
					                   :disabled="!question.hasMinMax">
							</span>
				                </label>
				                <label class="display-block">
					                <input type="checkbox" v-model="question.allowDecimals" value="Single" name="subType"/>
					                <span class="">Allow decimals</span>
				                </label>
			                </div>
			                <div class="" v-if="selectedType === 'SINGLE_CHOICE'">
				                <div class="vsb-choices-text">{{ __('questionnaires.answerlabels') }}</div>
				                <div class="" v-for="(option, index) in question.options" :key="index">
					                <div class="row">
						                <div class="col-md-12">
							                <validation-provider v-slot="{ errors }" class="form-group clear-both mb-2" :name="`single choice ` + `${index + 1}`" rules="required" tag="div">
								                <input type="text" :class="{'is-invalid': errors.length}" class="form-control" placeholder=""
								                       v-model="option.body">
								                <div class="d-flex justify-content-between mt-0 mb-2">
									                <div class="col-6">
										                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
									                </div>
									                <button class="col-6 vsb-btn-link color-red text-right width-10 mt-0"
									                        v-on:click="deleteQuestionOptionItem(question.options, index)" v-if="index > 1 && selectedType === 'SINGLE_CHOICE'">{{ __('actions.delete') }}
									                </button>
								                </div>
							                </validation-provider>
						                </div>
					                </div>
				                </div>
				                <div v-if="selectedType === 'SINGLE_CHOICE'" class="display-block">
					                <button class="vsb-btn-link color-blue" v-on:click="addAnotherAnswer()">{{ __('questionnaires.question-answer-add') }}</button>
				                </div>
			                </div>
			                <div class="" v-if="selectedType === '3_POINT_GRADING_SCALE' || selectedType === '4_POINT_GRADING_SCALE'">
				                <div class="row">
                                    <div class="col-md-10">
                                        <div class="vsb-choices-text">{{ __('questionnaires.answerlabels') }}</div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="vsb-choices-text">{{ __('questionnaires.answergrades') }}</div>
                                    </div>
                                </div>
				                <div class="" v-for="(option, index) in question.options" :key="index">
					                <div class="row">
						                <div class="col-md-10">
							                <validation-provider v-slot="{ errors }" class="form-group clear-both mb-2" :name="`single choice ` + `${index + 1}`" rules="required" tag="div">
								                <input type="text" :class="{'is-invalid': errors.length}" class="form-control" placeholder=""
								                       v-model="option.body">
								                <div class="d-flex justify-content-between mt-0 mb-2">
									                <div class="col-6">
										                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
									                </div>
									                <button class="col-6 vsb-btn-link color-red text-right width-10 mt-0"
									                        v-on:click="deleteQuestionOptionItem(question.options, index)" v-if="index > 1 && selectedType === 'SINGLE_CHOICE'">{{ __('actions.delete') }}
									                </button>
								                </div>
							                </validation-provider>
						                </div>
						                <div class="col-md-2">
							                <validation-provider v-slot="{ errors }" class="form-group clear-both mb-2" :name="`attribute ` + `${index + 1}`" rules="required" tag="div">
								                <input type="number" :class="{'is-invalid': errors.length}" step=".1" class="form-control" v-model="option.attribute">
								                <div class="d-flex justify-content-between mt-0 mb-2">
									                <div class="col-6">
										                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
									                </div>
								                </div>
							                </validation-provider>
						                </div>
					                </div>
				                </div>
				                <div v-if="selectedType === 'SINGLE_CHOICE'" class="display-block">
					                <button class="vsb-btn-link color-blue" v-on:click="addAnotherAnswer()">{{ __('questionnaires.question-answer-add') }}</button>
				                </div>
			                </div>
			                <div class="" v-if="selectedType === 'TEXT'">
				                <label>
					                <input type="checkbox" v-model="question.characterLimited" name="characterLimited"/>
					                <span class="">
								Character limit
								<input type="number" class="form-control char-limit-input"
								       v-model="question.textLimit" placeholder="" min="1" max="2048"
								       :disabled="!question.characterLimited">
							    </span>
				                </label>
			                </div>
			                <div class="" v-if="selectedType === 'TIME'">
				                <div class="">
					                <label class=""><input type="radio" v-model="question.timeFormat" value="12"
					                                       v-on:click="timeFormatModified(question.timeFormat)"> 12 hrs</label>
					                <label>
						                <input type="radio" v-model="question.timeFormat" value="24"
						                       v-on:click="timeFormatModified(question.timeFormat)"> 24 hrs</label>
				                </div>
			                </div>
		                </template>
						<div class="buttons-section">
							<button v-if="selectedType !== 'DEFAULT'" type="submit" class="btn btn-outline-primary">{{ __('actions.save') }}</button>
							<button type="button" class="btn btn-outline-secondary" @click="cancelQuestion(question)">{{ __('actions.cancel') }}</button>
						</div>
	                </form>
	            </validation-observer>
			</div>
		</div>
	</div>
</template>

<script>
import sampleQuestionObj from './survey-builder.json' ;
export default {
	name: 'SurveyBuilder',
	data() {
		return {
			question: this.questionProp,
			selectedType: null,
		};
	},

	props: {
		questionProp: {
			type: Object,
			required: false,
			default() {
				return JSON.parse(JSON.stringify(sampleQuestionObj))
			}
		},

		questionTypes: {
			type: Array,
			required: true,
		},

		sectionIndex: {
			required: true
        }
	},

	mounted() {
		this.question.type = this.question.type ? this.question.type : 'DEFAULT';
		this.selectedType = this.question.type;
	},

	methods: {
		questionTypeChanged(type) {
			this.question.type = this.selectedType;
			switch (type) {
				case 'BOOLEAN':
					this.question.options = [{body: this.__('questionnaires.q-boolean-yes'), sequence: 1}, {body: this.__('questionnaires.q-boolean-no'), sequence: 2}];
					break;
				case 'MULTI_CHOICE':
					this.question.options = [{body: null, sequence: 1}, {body: null, sequence: 2}];
					break;
				case 'SINGLE_CHOICE':
					this.question.options = [{body: null, sequence: 1}, {body: null, sequence: 2}];
					break;
				case '3_POINT_GRADING_SCALE':
					this.question.options = [
						{body: this.__('questionnaires.q-3pointgrading-1'), sequence: 1, attribute: 4},
						{body: this.__('questionnaires.q-3pointgrading-2'), sequence: 2, attribute: 7},
						{body: this.__('questionnaires.q-3pointgrading-3'), sequence: 3, attribute: 10}
					];
					break;
                case '4_POINT_GRADING_SCALE':
                    this.question.options = [
						{body: this.__('questionnaires.q-4pointgrading-1'), sequence: 1, attribute: 4},
	                    {body: this.__('questionnaires.q-4pointgrading-2'), sequence: 2, attribute: 6},
	                    {body: this.__('questionnaires.q-4pointgrading-3'), sequence: 3, attribute: 8},
	                    {body: this.__('questionnaires.q-4pointgrading-4'), sequence: 4, attribute: 10}
                    ];
					break;
				default:
					window.console.log('Question type not matched');
			}
		},

		timeFormatModified(format) {
			window.console.log(format);
		},

		addAnotherAnswer() {
			if (!this.question.options) {
				this.question.options = [];
			}
			let maxSequence = Number(Math.max(...this.question.options.map(x => x.sequence)));
			if (!maxSequence) {
				maxSequence = this.question.options.length;
			}
			this.question.options.push({body: null, sequence: maxSequence + 1, nextQuestion: null, imageUrl: null}); // eslint-disable-line
			this.$forceUpdate();
		},

		deleteQuestionOptionItem(options, index) {
			this.question.options.splice(index, 1);
		},

		getGUID() {
			function s4() {
				return Math.floor((1 + Math.random()) * 0x10000)
					.toString(16)
					.substring(1);
			}

			return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`;
		},

		saveQuestion() {
			this.question.id = this.question.id ? this.question.id : this.getGUID();
			this.$root.$emit('add-update-question', {question: this.question, index: this.sectionIndex});
			this.question = JSON.parse(JSON.stringify(sampleQuestionObj));
		},

		cancelQuestion() {
			this.question = JSON.parse(JSON.stringify(sampleQuestionObj));
			this.$emit('cancel');
		},

		changeLabelsLength(intervals) {
			this.question.labels.length = intervals;
		},
	},
};
</script>

<style scoped lang="scss">
$color-primary: #fff;
$color-secondary: #eaf0f4;
$color-blue: #4c8ce4;
$color-orange: #ff9635;
$color-red: #f06559;
$color-green: #48bf7a;

.color-blue {
	color: $color-blue;
}

.color-orange {
	color: $color-orange;
}

.color-red {
	color: $color-red;
}

.color-green {
	color: $color-green;
}

.vue-survey-builder-content {
	input[type='text'],
	input[type='number'],
	select {
		font-size: 14px;
		background-color: #fff;
	}

	.float-left {
		float: left;
	}

	.float-right {
		float: right;
	}

	.text-center {
		text-align: center;
	}

	.text-right {
		text-align: right;
	}

	.width-90 {
		width: 90% !important;
		display: inline-block;
	}

	.width-10 {
		width: 10% !important;
		display: inline-block;
	}

	.display-block {
		display: block;
		clear: both;
	}

	.display-inline-block {
		display: inline-block;
		clear: both;
	}

	.clear-both {
		clear: both;
	}

	.vsb-btn-link {
		border: none;
		background: none;
		padding: 5px;
	}

	.question-section {
		padding: 10px 0;
		margin: auto;
	}

	.vsb-block {
		display: block;
		padding: 5px 0;
	}

	.vsb-choices-text {
		font-size: 16px;
	}

	.vsb-select {
		max-width: 200px;
	}

	.char-limit-input {
		max-width: 100px;
	}

	.buttons-section {
		padding-top: 20px;
		clear: both;
	}

	*:focus {
		outline: none;
	}

	.scale-type {
		.intervals input {
			width: 60px;
		}
	}
}
</style>
